<div class="request-confirmation">
	<div class="head">
		<i class="icon-verified"></i>
		<span>
			{{'REQUEST.CONFIRMATION.CONFIRMATION_CODE' | translate}}
		</span>
	</div>
	<div class="content" [ngClass]="{'content-disabled': !informationAccepted}">
		<span class="explane"
			*ngIf="sendType === confirmCodeSendType.Email">{{'REQUEST.CONFIRMATION.CONFIRMATION_HELP_EMAIL' |
			translate}}</span>
		<span class="explane"
			*ngIf="sendType === confirmCodeSendType.SMS">{{'REQUEST.CONFIRMATION.CONFIRMATION_HELP_SMS' |
			translate}}</span>

		<span class="explane"
			*ngIf="sendType === confirmCodeSendType.TwoFactorAuthentication">{{'REQUEST.CONFIRMATION.CONFIRMATION_HELP_2FA'
			| translate}}</span>

		<form [formGroup]="form" class="recive-code" autocomplete="off">
			<div class="tc-form-field size-md" *ngIf="sendType !== confirmCodeSendType.TwoFactorAuthentication">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field ltr-en-input">
					<input matInput formControlName="email">
				</mat-form-field>
				<button mat-flat-button class="btn-tc size-sm btn-primary-new send-code" [disableRipple]="true"
					appMousePress [TcPromise]="submitSubscription" [disabled]="!timeIsExpired || !enableConfirmation"
					(click)="sendCode()">
					<span *ngIf="timeIsExpired">{{'REQUEST.CONFIRMATION.SEND_CODE' | translate}}</span>
					<tc-countdown-new *ngIf="!timeIsExpired" [leftTime]="interval" (finishedEmit)="onTimerFinished()">
					</tc-countdown-new>
				</button>
			</div>
			<div class="tc-form-field size-md" *ngIf="sendType !== confirmCodeSendType.TwoFactorAuthentication">
				<label class="label">
					{{'REQUEST.CONFIRMATION.SECURITY_CODE' | translate}}
					<span class="required">*</span>
				</label>
				<mat-form-field appearance="outline" subscriptSizing="dynamic"
					class="input-field ltr-en-input for-confirm-code">
					<input id="codeInput" matInput formControlName="secureCode" maxlength="6" placeholder="______"
						[readonly]="timeIsExpired">
				</mat-form-field>
			</div>
			<div class="tc-form-field size-md" *ngIf="sendType === confirmCodeSendType.TwoFactorAuthentication">
				<label class="label">
					{{'REQUEST.CONFIRMATION.AUTHENTICATOR_CODE' | translate}}
					<span class="required">*</span>
				</label>
				<mat-form-field appearance="outline" subscriptSizing="dynamic"
					class="input-field ltr-en-input for-confirm-code">
					<input id="codeInput" matInput formControlName="secureCode" maxlength="6" placeholder="______">
					<mat-hint>{{'REQUEST.CONFIRMATION.ENTER_CODE_FROM_AUTHENTICATOR' | translate}}</mat-hint>
				</mat-form-field>
			</div>
		</form>
	</div>
	<div [ngClass]="{'disable-box': !informationAccepted}"></div>
</div>
<!-- OLD Version

<div class="request-confirmation">
    <div class="head">
        <i class="icon-verified"></i>
        <span>
			{{'REQUEST.CONFIRMATION.CONFIRMATION_CODE' | translate}}
		</span>
    </div>
    <div class="content" [ngClass]="{'content-disabled': !informationAccepted}">
        <span class="explane" *ngIf="sendType === confirmCodeSendType.Email">{{'REQUEST.CONFIRMATION.CONFIRMATION_HELP_EMAIL' | translate}}</span>
        <span class="explane" *ngIf="sendType === confirmCodeSendType.SMS">{{'REQUEST.CONFIRMATION.CONFIRMATION_HELP_SMS' | translate}}</span>
        <form [formGroup]="form" class="recive-code" autocomplete="off">
            <mat-form-field appearance="outline" class="confirm-email">
                <input class="ltr-dir" matInput formControlName="email">
                <button mat-flat-button [TcPromise]="submitSubscription" [disabled]="!timeIsExpired || !enableConfirmation" (click)="sendCode()">
             <span *ngIf="timeIsExpired">{{'REQUEST.CONFIRMATION.SEND_CODE' | translate}}</span>
			<tc-countdown *ngIf="!timeIsExpired" [leftTime]="interval" (finishedEmit)="onTimerFinished()"></tc-countdown>
		  </button>

            </mat-form-field>
            <mat-form-field appearance="outline" class="confirm-code">
                <mat-label>{{'REQUEST.CONFIRMATION.SECURITY_CODE' | translate}}</mat-label>
                <input id="codeInput" matInput formControlName="secureCode" maxlength="6" placeholder="______" [readonly]="timeIsExpired">
            </mat-form-field>
        </form>
    </div>
    <div [ngClass]="{'disable-box': !informationAccepted}"></div>
</div> -->